export default __webpack_public_path__ + "static/media/bootstrapLogo.997c463d.svg";